import { useTranslation } from 'react-i18next'
import { GymDialog } from '../../components/GymDialog'

interface Props {
  mapUrl: string
  mapFileType: 'pdf' | 'image'
  isOpen: boolean
  onClose: () => void
}

export function GymMapPreviewModal({ mapUrl, mapFileType, isOpen, onClose }: Props) {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <GymDialog onClose={onClose} size="2xl">
      <div className="flex flex-col p-4">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-base font-semibold">{t('routes.gymMap.title')}</h2>
          <button
            onClick={onClose}
            className="flex h-7 w-7 items-center justify-center rounded-full text-foreground/50 hover:bg-content2 hover:text-foreground"
            aria-label={t('common.close')}
          >
            ×
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-auto">
          {mapFileType === 'image' ? (
            <img
              src={mapUrl}
              alt={t('routes.gymMap.title')}
              className="w-full rounded-xl object-contain"
            />
          ) : (
            <iframe
              src={mapUrl}
              title={t('routes.gymMap.title')}
              className="h-[70vh] w-full rounded-xl border border-divider"
            />
          )}
        </div>

        <a
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 text-center text-sm text-primary hover:underline"
        >
          {t('routes.gymMap.openInNewTab')}
        </a>
      </div>
    </GymDialog>
  )
}
